import { render, staticRenderFns } from "./MatomoUserProfile.vue?vue&type=template&id=2baa0889&"
import script from "./MatomoUserProfile.vue?vue&type=script&lang=js&"
export * from "./MatomoUserProfile.vue?vue&type=script&lang=js&"
import style0 from "./MatomoUserProfile.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "MatomoUserProfile.vue"
export default component.exports